// Definición de defaults

export const defaultEtapa: EtapaProps = {
    idEtapa:        0,
    descripcion:    '',
    activo:         false,
}

// Creación de interfaces

export interface EtapaProps {
    idEtapa:        number;
    descripcion:             string;
    activo:                  boolean;
}